<template>
  <el-form
    ref="ruleForm"
    :model="item"
    label-position="left"
    label-width="160px"
  >
    <el-form-item label="Material Mode">
      <el-radio-group v-model="item.material_type">
        <el-radio :label="CONSTANT.MATERIAL_TYPE.IMAGES">Images</el-radio>
        <el-radio :label="CONSTANT.MATERIAL_TYPE.HTML">Html</el-radio>
      </el-radio-group>
    </el-form-item>
    <el-divider>
      <span class="pink">
        {{
          item.material_type === CONSTANT.MATERIAL_TYPE.IMAGES
            ? "Image"
            : "Html"
        }}
      </span>
    </el-divider>
    <el-form-item
      v-for="key in ['initial', 'expanded']"
      :key="key"
      :label="_.startCase(key) + switchMaterialType().label"
      :prop="`${key}.${switchMaterialType().prop}`"
      :rules="
        item.material_type === CONSTANT.MATERIAL_TYPE.IMAGES
          ? [...imageSizeRule(limited_size[key]), ...urlRule('image_url')]
          : urlRule('html_url')
      "
    >
      <file-input
        :accept="switchMaterialType().accept"
        v-model="item[key][switchMaterialType().prop]"
        :check_upload_image_size="{
          ...limited_size[key],
          enable: item.material_type === CONSTANT.MATERIAL_TYPE.IMAGES,
        }"
      ></file-input>
    </el-form-item>
    <div v-show="item.material_type === CONSTANT.MATERIAL_TYPE.HTML">
      <el-form-item label="Html play time">
        <el-input-number
          v-model="item.millisecond"
          :step="1000"
          :min="0"
          :max="99000"
          :disabled="item.material_type === CONSTANT.MATERIAL_TYPE.IMAGES"
        ></el-input-number>
        <span> millisecond</span>
      </el-form-item>
      <el-form-item label="Loop">
        <el-switch v-model="item.loop">Loop Html play</el-switch>
      </el-form-item>
      <el-form-item label="Times">
        <el-input-number
          v-model="item.times"
          :step="1"
          :min="0"
          :max="9999"
          :disabled="
            item.material_type === CONSTANT.MATERIAL_TYPE.IMAGES ||
              item.loop === true
          "
        ></el-input-number>
      </el-form-item>
    </div>
    <video-item ref="video" replay v-if="withOutstream">
      <div v-for="key in ['initial', 'expanded']" :key="key">
        <el-divider content-position="left">
          <span class="blue">
            {{ _.startCase(key) + " Video" }}
          </span>
        </el-divider>
        <video-size
          :ref="key + 'VideoSize'"
          v-model="item[key].video"
          :max-width="970"
          :max-height="key === 'initial' ? 250 : 500"
        ></video-size>
      </div>
    </video-item>
  </el-form>
</template>

<script>
import MixFormRule from "@/components/mixins/formRule";
import MixCreativeForm from "@/components/mixins/creativeForm";

export default {
  data() {
    return {
      item: {
        material_type: CONSTANT.MATERIAL_TYPE.IMAGES || 0,
        millisecond: 0,
        loop: true,
        times: 0,
        initial: {
          image_url: "",
          html_url: "",
          video: {
            height: 0,
            width: 0,
            vertical: {
              align: "center",
              padding: 0,
            },
            horizontal: {
              align: "center",
              padding: 0,
            },
          },
        },
        expanded: {
          image_url: "",
          html_url: "",
          video: {
            height: 0,
            width: 0,
            vertical: {
              align: "center",
              padding: 0,
            },
            horizontal: {
              align: "center",
              padding: 0,
            },
          },
        },
      },
      withOutstream: _.includes(this.value._type, "WithOutstream"),
      limited_size: {
        initial: {
          width: {
            max: 970,
            min: 970,
          },
          height: {
            max: 250,
            min: 250,
          },
        },
        expanded: {
          width: {
            max: 970,
            min: 970,
          },
          height: {
            max: 500,
            min: 500,
          },
        },
      },
    };
  },
  mixins: [MixFormRule, MixCreativeForm],
  methods: {
    switchMaterialType() {
      let items = {};
      if (this.item.material_type === CONSTANT.MATERIAL_TYPE.HTML) {
        items.label = "Html";
        items.accept =
          "application/zip, application/x-zip-compressed, application/zip-compressed";
        items.prop = "html_url";
      } else {
        items.label = "Image";
        items.accept = "image/jpeg, image/png, image/gif";
        items.prop = "image_url";
      }
      return items;
    },
    setData(row) {
      this.item.material_type = row.material_type;
      if (row.material_type === CONSTANT.MATERIAL_TYPE.HTML) {
        this.item.millisecond = row.millisecond;
        if (row.times === -1) {
          this.item.loop = true;
        } else {
          this.item.loop = false;
        }
        this.item.times = row.times;
      }
      _.forEach(["initial", "expanded"], (key) => {
        this.item[key].image_url = decodeURI(row[`${key}_image_url`]);
        this.item[key].html_url = decodeURI(row[`${key}_html_url`] || "");
      });
      if (this.withOutstream) {
        this.$refs.video.setData(row);

        _.forEach(["initial", "expanded"], (key) => {
          this.item[key].video.height = row[`${key}_video_height`];
          this.item[key].video.width = row[`${key}_video_width`];
          _.forEach(["vertical", "horizontal"], (subKey) => {
            this.item[key].video[subKey].align = row[`${key}_${subKey}_align`];
            if (row[`${key}_${subKey}_align`] !== "center") {
              this.item[key].video[subKey].padding =
                row[`${key}_${subKey}_padding`];
            }
          });
        });
      }
    },
    async getData(setObj) {
      setObj.material_type = this.item.material_type;
      if (this.item.material_type === CONSTANT.MATERIAL_TYPE.HTML) {
        setObj.millisecond = this.item.millisecond;
        if (this.item.loop) {
          setObj.times = -1;
        } else {
          setObj.times = this.item.times;
        }
      }
      _.forEach(["initial", "expanded"], (key) => {
        setObj[`${key}_image_url`] = this.item[key].image_url.replace(/[^\x00-\x7F]/g, (c) => encodeURI(c));
        setObj[`${key}_html_url`] = this.item[key].html_url.replace(/[^\x00-\x7F]/g, (c) => encodeURI(c));
      });

      if (this.withOutstream) {
        _.forEach(["initial", "expanded"], (key) => {
          const video = this.item[key].video;
          setObj[`${key}_video_height`] = video.height;
          setObj[`${key}_video_width`] = video.width;
          _.forEach(["vertical", "horizontal"], (subKey) => {
            setObj[`${key}_${subKey}_align`] = video[subKey].align;
            if (video[subKey].align !== "center") {
              setObj[`${key}_${subKey}_padding`] = video[subKey].padding;
            }
          });
        });

        setObj = await this.$refs.video.getData(
          setObj,
          setObj.initial_video_width,
          setObj.initial_video_height
        );
      }
      return setObj;
    },
  },
};
</script>

<style></style>
